module.exports = __webpack_public_path__ + "img/default-avatar.f7366b44.png";